<template>
  <div>
    <b-img :src="require('@/assets/level_up.jpg')" fluid />
  </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'

export default {
  components: {
    BImg
  },
  data() {
    return {
    }
  }
}
</script>

<style>

</style>
